import React from 'react';
import { HiLibrary, HiArrowNarrowLeft, HiSparkles, HiOutlineDocumentText, HiOutlineCloudUpload } from 'react-icons/hi';
import { useNavigate } from 'react-router-dom';

const LibraryPageBanner = () => {
  const navigate = useNavigate();

  return (
    <div className="flex items-center justify-center w-full pt-4">
      <div className="max-w-2xl w-full">
        <div className="relative group rounded-[2.5rem] p-[2px] bg-gradient-to-b from-blue-400 via-indigo-500 to-purple-600 shadow-2xl overflow-hidden transition-all duration-500 hover:shadow-blue-500/20">
          
          {/* Inner Content */}
          <div className="bg-[#0A0F1C] rounded-[2.4rem] p-10 md:p-14 relative overflow-hidden z-10 text-center">
            
            {/* Background Effects */}
            <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-full bg-[radial-gradient(ellipse_at_top,_var(--tw-gradient-stops))] from-blue-900/40 via-[#0A0F1C] to-[#0A0F1C] -z-10"></div>
            <div className="absolute -top-24 -right-24 w-64 h-64 bg-blue-500/20 rounded-full blur-[80px] -z-10 pointer-events-none group-hover:bg-blue-500/30 transition-all duration-700"></div>
            <div className="absolute -bottom-24 -left-24 w-64 h-64 bg-purple-500/20 rounded-full blur-[80px] -z-10 pointer-events-none group-hover:bg-purple-500/30 transition-all duration-700"></div>

            {/* Glowing Icon */}
            <div className="relative inline-flex mb-8">
              <div className="absolute inset-0 bg-blue-500 rounded-3xl blur-xl opacity-50 animate-pulse"></div>
              <div className="relative w-24 h-24 bg-gradient-to-br from-blue-500 to-indigo-600 rounded-[2rem] flex items-center justify-center border border-white/10 shadow-2xl text-white transform -rotate-6 group-hover:rotate-0 transition-transform duration-500">
                <HiLibrary size={44} />
              </div>
              <div className="absolute -top-3 -right-3 bg-amber-400 text-slate-900 p-2.5 rounded-2xl shadow-xl transform rotate-12 animate-bounce">
                <HiSparkles size={20} />
              </div>
            </div>

            {/* Badge */}
            <div className="flex justify-center mb-6">
              <div className="inline-flex items-center gap-2 px-4 py-2 bg-blue-500/10 border border-blue-400/20 rounded-full relative">
                <div className="relative flex h-2 w-2">
                  <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-blue-400 opacity-75"></span>
                  <span className="relative inline-flex rounded-full h-2 w-2 bg-blue-500"></span>
                </div>
                <span className="text-blue-300 text-[10px] font-black uppercase tracking-widest">
                  Coming Soon • In Development
                </span>
              </div>
            </div>

            {/* Heading */}
            <h2 className="text-4xl md:text-5xl font-black text-white tracking-tight mb-6">
              The Digital <span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-400 to-purple-400">Library</span>
            </h2>

            {/* Description */}
            <p className="text-slate-400 text-sm md:text-base font-medium leading-relaxed mb-10 max-w-lg mx-auto">
              We're optimizing our high-speed <strong className="text-white">Cloud Storage</strong>. Soon, you'll be able to seamlessly access and share notes, PYQs, and study materials across the network.
            </p>

            {/* Feature Highlights */}
            <div className="grid grid-cols-2 gap-4 mb-10 text-left max-w-md mx-auto">
              <div className="bg-white/5 border border-white/10 rounded-2xl p-4 backdrop-blur-sm hover:bg-white/10 transition-colors">
                <HiOutlineDocumentText className="text-amber-400 mb-2" size={24} />
                <h4 className="text-white text-xs font-bold uppercase tracking-wider mb-1">Resources</h4>
                <p className="text-slate-500 text-[10px] font-medium leading-tight">Access premium study materials instantly.</p>
              </div>
              <div className="bg-white/5 border border-white/10 rounded-2xl p-4 backdrop-blur-sm hover:bg-white/10 transition-colors">
                <HiOutlineCloudUpload className="text-blue-400 mb-2" size={24} />
                <h4 className="text-white text-xs font-bold uppercase tracking-wider mb-1">Contribute</h4>
                <p className="text-slate-500 text-[10px] font-medium leading-tight">Upload your notes to help juniors ace exams.</p>
              </div>
            </div>

            {/* CTA */}
            <button 
              onClick={() => navigate('/')}
              className="group/btn relative inline-flex items-center justify-center gap-3 bg-white text-slate-900 px-8 py-4 rounded-2xl font-black text-xs uppercase tracking-widest hover:bg-slate-100 transition-all active:scale-95 overflow-hidden shadow-[0_0_20px_rgba(255,255,255,0.3)] hover:shadow-[0_0_30px_rgba(255,255,255,0.5)]"
            >
              <span className="absolute inset-0 bg-gradient-to-r from-transparent via-slate-200/50 to-transparent -translate-x-full group-hover/btn:translate-x-full transition-transform duration-700"></span>
              <HiArrowNarrowLeft className="group-hover/btn:-translate-x-1 transition-transform" size={16} />
              Return to Dashboard
            </button>
          </div>
        </div>
        
        {/* Support Footer */}
        <p className="mt-8 text-center text-slate-400 text-[11px] font-medium uppercase tracking-widest">
          Expected Launch: Spring 2026 • CampusIRA Beta
        </p>
      </div>
    </div>
  );
};

export default LibraryPageBanner;